// extracted by mini-css-extract-plugin
module.exports = {"rangePicker":"date-picker_rangePicker__2ugiF"};